import api from '@pray/shared/utils/api';

import type {
  CreateWarmupCampaignPayload,
  WarmupAudience,
  WarmupAudiencePayload,
  WarmupCampaign,
  WarmupPlan,
} from './types';

export async function createWarmupCampaign({
  artistId,
  payload,
}: {
  artistId: string;
  payload: CreateWarmupCampaignPayload;
}): Promise<{ object: WarmupCampaign; plan: WarmupPlan }> {
  if (!artistId) throw new Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/warmup-campaigns`;
  const response = await api.executePostRequest<{ data: { object: WarmupCampaign; plan: WarmupPlan } }>(url, payload);
  return response.data.data;
}

export async function createWarmupAudience({
  artistId,
  warmupId,
  audience,
}: {
  artistId: string;
  warmupId: string;
  audience: WarmupAudiencePayload;
}): Promise<{ object: WarmupAudience }> {
  const url = `/web/studio/artists/${artistId}/warmup-campaigns/${warmupId}/audiences`;
  const response = await api.executePostRequest<{ data: { object: WarmupAudience } }>(url, audience);
  return response.data.data;
}
